<template>
  <div class="detail-box position-header" v-loading="loading">
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="14">
            <div style="height: 50vh; overflow: auto; padding-right: 10px">
              <el-form ref="form" class="add-form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="联系人：" prop="contacts">
                  <el-input v-model="form.contacts" disabled></el-input>
                </el-form-item>
                <el-form-item label="图片：" prop="logo">
                  <template v-for="(item, index) of logoList">
                    <el-image :src="item" :key="index"></el-image>
                  </template>
                </el-form-item>
                <el-form-item label="手机号码：" prop="phone">
                  <el-input v-model="form.phone" disabled></el-input>
                </el-form-item>
                <el-form-item label="微信号：" prop="weChat">
                  <el-input v-model="form.weChat" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司名称：" >
                  <el-input v-model="form.company.fullName" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司简称：" >
                  <el-input v-model="form.company.shortName" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司地址：" >
                  <el-input v-model="form.company.address" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司地址：" >
                  <el-input v-model="form.company.address" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司简介：" >
                  <el-input v-model.trim="form.company.introduction" type="textarea" :rows="8" disabled></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="info-footer">
              <el-button @click="back">返回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/uploadImage.vue'

export default {
  name: 'mateMeetBannerDetail',
  data () {
    return {
      loading: true,
      id: '',
      title: '添加',
      type: 'add',
      bannerTypeList: [],
      mainIdList: [],
      logoList: [],
      form: {
        contacts: '',
        logo: '',
        phone: '',
        weChat: '',
        company: {}
      },
      rules: {
        title: {
          required: true, message: '请输入标题', trigger: 'blur'
        }
      }
    }
  },
  components: {
    navHeader,
    uploadImage
  },
  methods: {
    getDetail (meetRecordId) {
      this.$http.post('/meetSession/meetSession/getMeetRecordDetail', {meetRecordId}).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.logoList = res.data.data.logo ? res.data.data.logo.split(',') : []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    back () {
      this.$emit('isShowList')
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/meetSession/sessionDetail.vue